import SessionManager from '../utils/session';

const BASE_PATH = 'AUTH';

export const SET_AUTH_USER = `${BASE_PATH}/SET_AUTH_USER`;
export const CLEAR_AUTH_USER = `${BASE_PATH}/CLEAR_AUTH_USER`;

export const setAuthUser = (user, token, rt) => ({
    type: SET_AUTH_USER,
    user,
    token,
    rt
});

export const clearAuthUser = () => ({
    type: CLEAR_AUTH_USER,
});

const initialState = SessionManager.getAuthUser();


export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_AUTH_USER:
            SessionManager.setAuthToken(action.token);
            SessionManager.setAuthRToken(action.rt);
            SessionManager.setAuthUser({ user: action.user, isSignedIn: true });
            return {
                ...state,
                user: action.user,
                isSignedIn: true
            };
        case CLEAR_AUTH_USER:
            SessionManager.setAuthToken(null);
            SessionManager.setAuthRToken(null);
            SessionManager.setAuthUser(null);
            return {
                ...state,
                user: {},
                isSignedIn: false
            };
        default:
            break;
    }

    return state;
}